<template>
	<!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
	<div class="user">
		<!--搜索表单-->
		<div class="common-seach-wrap">
			<el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="技师ID">
				  <el-input v-model="formInline.waiter_user_id" placeholder="请输入技师ID"></el-input>
				</el-form-item>
				<el-form-item label="起始时间">
					<div class="block">
						<span class="demonstration"></span>
						<el-date-picker size="small" v-model="formInline.createTime" type="daterange"
							value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期"></el-date-picker>
					</div>
				</el-form-item>
				<el-form-item label="审核状态">
					<el-select v-model="formInline.status" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option label="待审核" value="1"></el-option>
						<el-option label="同意" value="2"></el-option>
						<el-option label="驳回" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市">
					<el-select v-model="formInline.city_id" placeholder="请选择">
						<el-option label="全部" value="0"></el-option>
						<el-option v-for="(item, index) in supplierList" :key="index" :label="item.city"
							:value="item.serviceCityId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--内容-->
		<div class="product-content">
			<div class="table-wrap">
				<el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
					<el-table-column prop="waiter_user_id" align="center" label="技师ID" width="100"></el-table-column>
					<el-table-column prop="avatarUrl" align="center" label="头像">
						<template slot-scope="scope" v-if="scope.row.waiter.avatarUrl">
							<img :src='scope.row.waiter.avatarUrl' alt="" width="50px" height="50px" />
						</template>
					</el-table-column>
					<el-table-column prop="" align="center" label="昵称">
						<template slot-scope="scope">
							<div>昵称：{{ scope.row.waiter.nickName }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="city" align="center" label="城市">
						<template slot-scope="scope">
							<div>{{ scope.row.city.city }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="reason" align="center" label="申请原因"></el-table-column>
					<el-table-column prop="status" align="center" label="审核状态">
						<template slot-scope="scope">
							<div>{{ scope.row.status==1?'待审核':scope.row.status==2?'通过':scope.row.status==3?'驳回':'' }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" align="center" label="提交时间"></el-table-column>
					
					<el-table-column fixed="right" align="center" label="操作" width="110">
						<template slot-scope="scope">
							<el-button @click="btnAudit(scope.row)" type="primary" size="small" v-if="scope.row.status == 1">审核</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!--分页-->
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
					:total="totalDataNumber"></el-pagination>
			</div>
		</div>
		<!--审核-->
		<el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
			<el-form :model="workerinfo" :rules="rules" ref="formName">
				<el-form-item label="是否允许" prop="status">
					<el-radio v-model="workerinfo.status" :label="2">审核通过</el-radio>
					<el-radio v-model="workerinfo.status" :label="3">审核不通过</el-radio>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type="textarea" v-model="workerinfo.remark" placeholder="请输入备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changestatus">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import Technician from "@/api/technician.js";
	export default {
		data() {
			return {
				rules: {
				  status: [
				    { required: true, message: '请选择！', trigger: 'blur' }
				  ]
				},
				dialogVisible: false,
				workerinfo: {
					status: null,
					remark:'',	// 备注
					id:''		// 申请记录id
				},
				/*是否加载完成*/
				loading: true,
				/*列表数据*/
				tableData: [],
				/*一页多少条*/
				pageSize: 15,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				/*横向表单数据模型*/
				formInline: {
					createTime: '', //开始时间
					waiter_user_id: '', //技师id
					city_id: '', //城市id
					status: '', //0 全部 1待审核 2同意 3驳回
				},
				supplierList: []
			};
		},
		created() {
			/*获取列表*/
			this.getTableList();
		},
		methods: {
			// 审核
			btnAudit(row) {
				this.workerinfo.id = row.id
				this.dialogVisible = true
			},
			// 修改审核状态
			changestatus() {
				let that = this
				if (that.workerinfo.status) {
					Technician.examine(that.workerinfo).then(data => {
						if (data.code == 1) {
							that.$message({
								type: 'success',
								message: data.msg
							});
						}
						that.loading = true;
						that.getTableList();
					});
				} else {
					console.log('选择', that.workerinfo);
				}
			
				this.dialogVisible = false
			},
			/*选择第几页*/
			handleCurrentChange(val) {
				let self = this;
				self.curPage = val;
				self.loading = true;
				self.getTableList();
			},

			/*每页多少条*/
			handleSizeChange(val) {
				this.curPage = 1;
				this.pageSize = val;
				this.getTableList();
			},

			/*获取列表*/
			getTableList() {
				let self = this;
				let Params = self.formInline;
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				Technician.CityLog(Params, true)
					.then(data => {
						self.loading = false;
						self.tableData = data.data.list.data;
						self.totalDataNumber = data.data.list.total;
						self.supplierList = data.data.cityList
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*搜索查询*/
			onSubmit() {
				let self = this;
				self.loading = true;
				let Params = self.formInline;
				self.getTableList();
			}
		}
	};
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/technician/migration/index.vue